<script setup>
import { onMounted } from 'vue';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions :column="3" :label-style="{ width: '20%' }" bordered>
    <a-descriptions-item label="Pasta vinculada" :span="3">
      <a-tooltip>
        <template #title> Ir para página da pasta </template>
        <a :href="`/pasta/${props.compromisso.data.pastaPrincipalCodigo}`">{{
          props.compromisso.data.pastaPrincipalNome
        }}</a>
      </a-tooltip>
    </a-descriptions-item>

    <a-descriptions-item label="Nome" :span="3">
      {{ props.compromisso.data.nome }}
    </a-descriptions-item>

    <a-descriptions-item label="Número CNJ" :span="3">
      {{ formatCnj(props.compromisso.data.numeroCnj) }}
    </a-descriptions-item>

    <a-descriptions-item label="Tipo" :span="3">
      {{ props.compromisso.data.tipoProcessoText }}
    </a-descriptions-item>

    <a-descriptions-item label="Arquivos" :span="3">
      <span v-if="props.compromisso.arquivos.length === 0"
        >Nenhum arquivo enviado</span
      >
      <ul v-else>
        <li
          v-for="arquivo in props.compromisso.arquivos"
          :key="arquivo.fileServiceId"
        >
          <a target="_blank" :href="getGoogleDriveUrl(arquivo.fileServiceId)">{{
            arquivo.nome
          }}</a>
        </li>
      </ul>
    </a-descriptions-item>
  </a-descriptions>
</template>
